<template>
    <main>
        <section class="section" style="height: 50vh;">
            <div class="container text-center d-flex flex-column h-100 justify-content-center">
                <h1>Please log in</h1>
                <a href="#" @click.prevent="openLoginModal">
                    Click here to log in
                </a>
            </div>
        </section>
    </main>
</template>

<script>
export default {
    mounted() {
        this.openLoginModal();
    },
    methods: {
        openLoginModal() {
            this.$root.$emit('open-login-modal');
        },
    },
};
</script>
